// extracted by mini-css-extract-plugin
export var circle = "_2u-2";
export var icon = "_2u-a";
export var iconHighlight = "_2u-0";
export var lg = "_2u-8";
export var md = "_2u-7";
export var outline = "_2u-4";
export var sm = "_2u-6";
export var square = "_2u-1";
export var xl = "_2u-9";
export var xs = "_2u-5";
export var xxs = "_2u-3";